// src/ContextMenu.js
import React from 'react';

const ContextMenu = ({ position, onDelete, onClose }) => {
  if (!position) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: position.y,
        left: position.x,
        backgroundColor: 'white',
        border: '1px solid #ccc',
        padding: '5px 0',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        zIndex: 1000,
      }}
      onMouseLeave={onClose}
    >
      <div
        style={{
          padding: '8px 12px',
          cursor: 'pointer',
        }}
        onClick={onDelete}
      >
        Verbindung löschen
      </div>
    </div>
  );
};

export default ContextMenu;